import { render, staticRenderFns } from "./passo5.vue?vue&type=template&id=22fd7c50&scoped=true&"
import script from "./passo5.vue?vue&type=script&lang=js&"
export * from "./passo5.vue?vue&type=script&lang=js&"
import style0 from "./passo5.vue?vue&type=style&index=0&id=22fd7c50&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22fd7c50",
  null
  
)

export default component.exports